
import { computed, defineComponent, PropType, Ref } from 'vue';
import { B2CFooterViewModel, FooterColumnModel } from '@/types/B2CcontentServerContract';
import { Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/vue';

export default defineComponent({
    name: 'PageFooterAccordion',
    components: { Disclosure, DisclosureButton, DisclosurePanel },
    props: {
        footer: {
            type: Object as PropType<B2CFooterViewModel>,
            required: true,
        },
    },
    setup(props) {
        const reversedFooterColumns: Ref<FooterColumnModel[]> = computed(() => {
            return [...props.footer.columns].reverse();
        });

        return {
            reversedFooterColumns,
        };
    },
});

